var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLastSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.548,
    height: 15.548,
    viewBox: "0 0 15.548 15.548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__icons8-time-machine",
    fill: "#4e4e57",
    d: "M9.774 2a7.728 7.728 0 0 0-5.853 2.7L2 2.777v4.665h4.664l-1.65-1.65a6.2 6.2 0 1 1-1.459 3.982H2A7.774 7.774 0 1 0 9.774 2zM9 5.11v4.99l2.56 2.56 1.1-1.1-2.1-2.1V5.11z",
    transform: "translate(-2 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastSearchIcon);
export default __webpack_public_path__ + "static/media/last-search-icon.2335329ca3ea154677e102733fe2b6a0.svg";
export { ForwardRef as ReactComponent };